var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRealityTvShows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Real-Estate-Action-House-Star--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Real Estate Action House Star Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.42 18.28a2.81 2.81 0 0 1 -0.71 -3.09 2.73 2.73 0 0 1 2.55 -1.69h1.35a0.51 0.51 0 0 0 0.46 -0.3l0.88 -2A2.8 2.8 0 0 1 20 11l0.39 0.9a0.32 0.32 0 0 0 0.61 -0.12 0.32 0.32 0 0 1 0.32 -0.32h2.18a0.5 0.5 0 0 0 0.34 -0.86L13 0.41a1.5 1.5 0 0 0 -2 0L0.16 10.64a0.5 0.5 0 0 0 0.34 0.86h2a0.5 0.5 0 0 1 0.5 0.5v10a1 1 0 0 0 1 1h6.35a0.5 0.5 0 0 0 0.5 -0.47 2.75 2.75 0 0 1 0.22 -0.92l0.72 -1.61a0.49 0.49 0 0 0 -0.13 -0.57Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.91 15.76a1.23 1.23 0 0 0 -1.17 -0.76H20.4a0.48 0.48 0 0 1 -0.45 -0.3l-1.28 -3a1.3 1.3 0 0 0 -2.34 0l-1.27 3a0.51 0.51 0 0 1 -0.46 0.3h-2.34a1.24 1.24 0 0 0 -1.17 0.76 1.27 1.27 0 0 0 0.33 1.4L13.47 19a0.51 0.51 0 0 1 0.13 0.57l-1.15 2.65a1.24 1.24 0 0 0 0.31 1.45 1.28 1.28 0 0 0 1.51 0.17l3 -1.69a0.53 0.53 0 0 1 0.49 0l3 1.69a1.27 1.27 0 0 0 1.5 -0.17 1.24 1.24 0 0 0 0.32 -1.45l-1.15 -2.65a0.49 0.49 0 0 1 0.12 -0.57l2.07 -1.84a1.28 1.28 0 0 0 0.29 -1.4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRealityTvShows);
export default ForwardRef;